
/* tslint:disable */
/* eslint-disable */
/**
 * CMS API
 * Content management API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {FetchOptions} from 'ofetch';
import type {
  ContentView,
} from '../models';
import {
    ContentViewFromJSON,
    ContentViewToJSON,
} from '../models';

export interface CguRequest {
    version?: string;
    locale?: string;
}

export interface ImpressumRequest {
    locale?: string;
}

/**
 * 
 */
export class LegalApiApi extends runtime.BaseAPI {

    /**
          */
    async cguRaw(requestParameters: CguRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<ContentView>> {
        const queryParameters: any = {};

        if (requestParameters['version'] != null) {
            queryParameters['version'] = requestParameters['version'];
        }

        if (requestParameters['locale'] != null) {
            queryParameters['locale'] = requestParameters['locale'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<ContentView>({
            path: `/cms/api/cgu`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=ContentViewFromJSON(response._data); }
        return response;
    }

    /**
          */
    async cgu(requestParameters: CguRequest = {}, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<ContentView> {
        const response = await this.cguRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
          */
    async impressumRaw(requestParameters: ImpressumRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<ContentView>> {
        const queryParameters: any = {};

        if (requestParameters['locale'] != null) {
            queryParameters['locale'] = requestParameters['locale'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<ContentView>({
            path: `/cms/api/impressum`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=ContentViewFromJSON(response._data); }
        return response;
    }

    /**
          */
    async impressum(requestParameters: ImpressumRequest = {}, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<ContentView> {
        const response = await this.impressumRaw(requestParameters, initOverrides);
        return response._data;
    }

}
